import { Link } from "react-router-dom";
import { CaretRight, WhatsappLogo } from "@phosphor-icons/react";

/**
 * ActionPanel — replaces the old ComingSoonPanel with a real, actionable pattern.
 *
 * Renders:
 *  - A heading + short body describing what the section is for.
 *  - One or more primary/secondary CTAs pointing to WORKING features
 *    (never labelled "Próximamente"). Optional WhatsApp fallback.
 *  - Optional supporting content (e.g. a list of related items).
 *
 * Use this on dashboard subpages whose full workflow (orders, real-time chat,
 * shipment tracking) is still being built, so users always land on something
 * useful instead of an empty placeholder.
 */
export default function ActionPanel({
    title,
    body,
    actions = [],
    whatsapp,
    testId = "action-panel",
    children,
}) {
    return (
        <div
            className="bg-white border border-border rounded-2xl p-6 sm:p-8"
            data-testid={testId}
        >
            <h3 className="font-display font-extrabold text-xl sm:text-2xl tracking-tight">
                {title}
            </h3>
            {body && (
                <p className="text-sm text-muted-foreground mt-2 max-w-2xl leading-relaxed">
                    {body}
                </p>
            )}

            {actions.length > 0 && (
                <div className="mt-5 flex flex-wrap gap-2">
                    {actions.map((a, i) => (
                        <Link
                            key={a.to + i}
                            to={a.to}
                            className={a.primary ? "btn-primary" : "btn-outline"}
                            data-testid={a.testId || `${testId}-cta-${i}`}
                        >
                            {a.icon ? <a.icon size={16} weight="fill" /> : null}
                            {a.label}
                            <CaretRight size={14} weight="bold" />
                        </Link>
                    ))}
                    {whatsapp && (
                        <a
                            href={whatsapp.href}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-outline"
                            data-testid={`${testId}-whatsapp`}
                        >
                            <WhatsappLogo size={16} weight="fill" />
                            {whatsapp.label || "Coordinar por WhatsApp"}
                        </a>
                    )}
                </div>
            )}

            {children ? <div className="mt-6">{children}</div> : null}
        </div>
    );
}
